const LiveshowChatTokens = require("liveshow-chat-tokens");

module.exports = (fox) => {
  const _ = {
    WOWZA_SERVER_HOST: ["live1.modelcentro.com", "live2.modelcentro.com"],

    LSLABEL_WOWZA_SERVER: "_lswzs_",
    EVENT_FULLSCREEN: "fullscreen",
    EVENT_NORMALSCREEN: "normalscreen",

    TIMEOUT_MAXCONNECT_TIMELENGTH: 1000 * 25,

    ERROR_INTERRUPTED: "connection.closed",
    ERROR_BAD_CONNECTION: "connection.server.notrespond",
  };

  const ROOM_ALIAS_LABEL = "_ralsl_";
  let timerId = 0;

  fox.registerWidget(
    "LSTranslator",
    {
      createController: function (...args) {
        const createClient = fox._liveshowController.controllerFactory(fox);
        return createClient(...args);
      },

      configure: function () {
        this.connectParams = {};

        this.fullscreen = false;

        this.registerOptions("", {
          autoRender: true,
        });

        this.callParent("configure", arguments);
      },

      init: function () {
        this._assignCallbacks();
        this.callParent("init", arguments);
      },

      _assignCallbacks: function () {
        var events = [
          "app_initialized",
          "stream_connection_success",
          "stream_connection_closed",
        ];

        var mixEvents = this._getEventCallbacks();

        if (fox.isArray(mixEvents)) {
          events = events.concat(mixEvents);
        }

        fox.each(
          events,
          function (e) {
            var cb = this[e];

            if (fox.isFunction(cb)) {
              this.handleEvent("@this", e, cb.bind(this));
            }
          },
          this
        );
      },

      onError: function (args) {
        if (fox._isNewfe) {
          /* if (__DEV__) */
          console.log(`[${this.getClass()}]: -> liveshow.error`, args);
        }

        return this.treatError(args.code, args);
      },

      _onEvent: function (args) {
        var event = [args.module, args.type];
        var isActivityEvent = event.indexOf("activity") !== -1;

        if (!isActivityEvent && fox._isNewfe) {
          /* if (__DEV__) */
          console.log(`[${this.getClass()}]: -> liveshow.event`, args);
        }

        if (args.subType) {
          event = event.concat(args.subType.split("."));
        }

        event = event.join("_");

        if (!isActivityEvent) {
          this.log(event.replace(/_/g, "."), args);
        }

        this.dispatchEvent(event, args);
      },

      getDisconnectToken: function () {
        return LiveshowChatTokens.publisherDisconnect;
      },

      getUserBlockToken: function () {
        return LiveshowChatTokens.blockUser;
      },

      getUserUnblockToken: function () {
        return LiveshowChatTokens.unblockUser;
      },

      getPaidShowRequestToken: function () {
        return LiveshowChatTokens.paidShowRequest;
      },

      getLeavePrivateToken: function () {
        return LiveshowChatTokens.leavePrivate;
      },

      getPrepareWebrtcTranslationToken: function () {
        return LiveshowChatTokens.prepareWebrtcTranslation;
      },

      getInterruptError() {
        return _.ERROR_INTERRUPTED;
      },

      getBadConnectionError() {
        return _.ERROR_BAD_CONNECTION;
      },

      getWowzaServer(idx = 0) {
        const server = this.connectParams.server || _.WOWZA_SERVER_HOST[idx];

        return (
          fox.utils.localStorage("getItem", _.LSLABEL_WOWZA_SERVER) || server
        );
      },

      connectSuccess: function () {
        clearTimeout(this.connectInProgress);

        return this;
      },

      setConnectParams: function ({ id, sign }) {
        const sessionId = Number(id);

        if (
          this.connectParams.sessionId !== sessionId &&
          this.connectParams.sign !== sign
        )
          this.connectParams.sessionId = sessionId;

        if (this.connectParams.sign !== sign) this.connectParams.sign = sign;

        return this;
      },

      addedToDom: function () {
        /* avoid double call on activate */
        clearTimeout(timerId);
        timerId = setTimeout(() => this.initApp(), 100);
      },

      getConnectParams: function () {
        return {
          sessionId: this.connectParams.sessionId,
          hash: this.connectParams.sign,
          url: this.getWowzaServer(1),
          streamName: this.connectParams.streamName,
          stunServer: this.connectParams.stunServer,
          channelName: this.connectParams.channelName,
          appId: this.connectParams.appId,
          token: this.connectParams.token,
          uid: this.connectParams.uid,
        };
      },

      initApp: function (targetNode, args = {}) {
        if (this.inst) return false;

        const params = fox.merge(
          {
            width: this.getOption("flashWidth") || 475,
            height: this.getOption("flashHeight") || 355,
          },
          args,
          this.getOption("flashParams") || {}
        );

        this.inst = this.controller.init(
          targetNode || this.dom1(this.getOption("flashContainer")),
          params,
          this.getConnectParams()
        );

        return true;
      },

      deactivate: function () {
        this.inst.release();
        delete this.inst;

        this.callParent("deactivate", arguments);
      },

      setFullscreen: function () {
        this.fullscreen = true;
        this.dispatchEvent(_.EVENT_FULLSCREEN);
      },

      exitFullscreen: function () {
        this.fullscreen = false;
        this.dispatchEvent(_.EVENT_NORMALSCREEN);
      },

      setFlashSize: function (res) {
        let ar = parseFloat((res.w / res.h).toFixed(2).slice(0, -1));
        let sw = fox.jQuery("body").width();
        let sh = fox.jQuery("body").height();
        let _ = this.getFullscreenMargins();
        let nw;
        let nh;

        if (this.fullscreen === true) {
          nw = sw - _.MARGIN_PLAYER_W;
          nh = nw / ar;

          if (nh > sh - _.MARGIN_PLAYER_H) {
            nh = sh - _.MARGIN_PLAYER_H;
            nw = nh * ar;
          }
        } else {
          nw = this.getOption("flashWidth");

          nh = nw / ar;

          if (nh > this.getOption("flashHeight")) {
            nh = this.getOption("flashHeight");
            nw = nh * ar;
          }
        }

        this.inst.setSize(nw, nh, true);
      },

      treatError: function (error, args) {
        var errorCode = 505;
        var errorRegexp = /^[A-E]?\d+$/;

        if (this.connectInProgress) {
          clearTimeout(this.connectInProgress);
        }

        if (fox.isObject(error) && error.id) {
          errorCode = error.id;
        } else if (errorRegexp.test(error)) {
          errorCode = error;
        } else if (error.split(".").length) {
          errorCode = error;
        }

        this.log(errorCode, args);

        return errorCode;
      },

      log: function (errorCode, args) {
        if (fox.cookie.get("debug")) {
          return false;
        }

        var api = this.getApi(fox.uniqid("liveshowLog_"), {
          method: "liveshow.log",
          sendTimezone: true,
          httpMethod: "post",
        });

        var params = {
          liveshowId: this.connectParams.sessionId,
          code: errorCode,
          userTimestamp: new Date().getTime(),
          userAgent: window.encodeURIComponent(navigator.userAgent),
        };

        if (fox.isObject(args)) {
          params.args = window.encodeURIComponent(JSON.stringify(args));
        }

        api.send(params);
      },

      getRoomAlias() {
        let sessionId = this.connectParams.sessionId;
        const tmpSessionId = localStorage.getItem(ROOM_ALIAS_LABEL);

        if (tmpSessionId) sessionId = tmpSessionId;

        return ["liveshow", "room", sessionId].join("_");
      },

      changeWowzaServer(server) {
        fox.utils.localStorage("setItem", _.LSLABEL_WOWZA_SERVER, server);

        delete this.inst;
        this.render();
      },

      resetWowzaServer() {
        fox.utils.localStorage("removeItem", _.LSLABEL_WOWZA_SERVER);

        delete this.inst;
        this.render();
      },
    },
    "Widget"
  );
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/widget/LSTranslator.es.js